'use client';

import { Github, Heart } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';

export function Footer() {
  const t = useTranslations('Footer');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="dark:bg-[#112240] light:bg-gray-50 border-t dark:border-[#233554] light:border-gray-200 mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 dark:text-[#a8b2d1] light:text-gray-600 text-sm">
            <span>{t('madeWith')}</span>
            <Heart className="w-4 h-4 text-[#ff5370] fill-current" />
            <span>{t('by')}</span>
            <a
              href="https://www.samuel-grangeon.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#64ffda] hover:underline font-medium"
            >
              Samuel Grangeon
            </a>
          </div>

          <div className="flex items-center gap-4 dark:text-[#a8b2d1] light:text-gray-600 text-sm">
            <span>&copy; {currentYear} Elementium. {t('allRights')}</span>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://github.com"
              target="_blank"
              rel="noopener noreferrer"
              className="dark:text-[#a8b2d1] light:text-gray-600 dark:hover:text-[#64ffda] light:hover:text-teal-600 transition-colors"
              aria-label="GitHub"
            >
              <Github className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div className="mt-4 pt-4 border-t dark:border-[#233554] light:border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs dark:text-[#a8b2d1] light:text-gray-600">
          <p>Powered by Next.js 16, Three.js, Tailwind CSS &amp; shadcn/ui</p>
          <p>{t('aiImages')}</p>
          <div className="flex items-center gap-4">
            <Link href="/terms" className="hover:text-[#64ffda] transition-colors">
              {t('terms')}
            </Link>
            <Link href="/privacy" className="hover:text-[#64ffda] transition-colors">
              {t('privacy')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
